"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ prefix, paramArr, }) {
    const prevSearchParams = new URLSearchParams();
    paramArr.forEach(({ key, val }) => prevSearchParams.set(key, val));
    window.history.replaceState(null, '', `${prefix}?${String(prevSearchParams)}`);
}
exports.default = default_1;
